module.exports = __webpack_public_path__ + "img/settings.d3fb767a.svg";